/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicStripePublishableKey } from '../models/PublicStripePublishableKey';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PaymentsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Stripe webhook
     * Stripe webhook for subscriptions and Connect booking payments
     * @returns any
     * @throws ApiError
     */
    public stripePlatformWebhook(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/payments/stripe/webhook',
        });
    }
    /**
     * PayPal webhook to handle payment events from PayPal
     * PayPal Webhook
     * @returns any
     * @throws ApiError
     */
    public payPalWebhook(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/payments/paypal/webhook',
        });
    }
    /**
     * PayPal connect callback to handle the result of the PayPal connect flow
     * PayPal Connect Callback
     * @param merchantId
     * @param productIntentId
     * @param isEmailConfirmed
     * @param accountStatus
     * @param permissionsGranted
     * @param consentStatus
     * @param riskStatus
     * @returns any
     * @throws ApiError
     */
    public payPalConnectCallback(
        merchantId: string,
        productIntentId: string,
        isEmailConfirmed: boolean,
        accountStatus: string,
        permissionsGranted: boolean,
        consentStatus: boolean,
        riskStatus: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payments/paypal/callback',
            query: {
                'merchantId': merchantId,
                'productIntentId': productIntentId,
                'isEmailConfirmed': isEmailConfirmed,
                'accountStatus': accountStatus,
                'permissionsGranted': permissionsGranted,
                'consentStatus': consentStatus,
                'riskStatus': riskStatus,
            },
        });
    }
    /**
     * Stripe Connect callback after therapist onboarding
     * Stripe Connect Callback
     * @param therapistId
     * @returns any
     * @throws ApiError
     */
    public stripeConnectCallback(
        therapistId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payments/stripe/callback',
            query: {
                'therapistId': therapistId,
            },
        });
    }
    /**
     * Stripe Connect refresh URL when onboarding link expires
     * Stripe Connect refresh URL
     * @param therapistId
     * @returns any
     * @throws ApiError
     */
    public stripeConnectRefresh(
        therapistId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payments/stripe/connect/refresh',
            query: {
                'therapistId': therapistId,
            },
        });
    }
    /**
     * Stripe publishable key
     * Stripe publishable key for client-side Stripe.js
     * @returns PublicStripePublishableKey
     * @throws ApiError
     */
    public getStripePublishableKey(): CancelablePromise<PublicStripePublishableKey> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/payments/stripe/publishable-key',
        });
    }
}
